import { RealtyDetailScreenContent } from "../../features/realtyDetail";

// Thin route wrapper — mirrors RealtyHomeScreen / RealtySearchScreen
// / RealtySavedScreen. Per R3.1: route shell only. All section
// content + fetch lives in the feature widget.

function RealtyDetailScreen() {
  return <RealtyDetailScreenContent />;
}

export default RealtyDetailScreen;
